module.exports = __webpack_public_path__ + "static/media/clouds.d2b9247a.svg";